import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import profileP from "../Images/profile-pic.png";
import NotificationModal from "../Component/Modal/NotificationModal";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import Swal from "sweetalert2";
import HttpClient from "../utils/HttpClient";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Header = () => {
  const initData = {
    newPassword: '',
    cnfPassword: ''
  }
  const [formData, setFormData] = useState(initData);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);


  const [loginData, setLoginData] = useState("")
  console.log("54fghd84h1vbx", loginData?.email)
  console.log("loginDataaa", loginData)
  const navigate = useNavigate()
  const [notificationmodal, setNotificationmodal] = useState(false);
  const notificationModal = () => {
    setNotificationmodal(true);
  };

  const [Searchmodal, setSearchmodal] = useState(false);
  const responSearch = () => {
    setSearchmodal(!Searchmodal);
  };

  const handClick = () => {
    if (document.querySelector("#responsiveMenu").click) {
      document.querySelector(".sidebarwrap").classList.add("show");
    } else {
      document.querySelector(".sidebarwrap").classList.remove("show");
    }
  };

  // >>>Handle Admin Logout<<< 
  const handleLogOut = () => {


    // toast.success("Logout SuccessFull");
    localStorage.clear();
    navigate("/login");
  };

  const handleLogoutNew = () => {

    Swal.fire({
      title: "Log Out?",
      text: "You want to logout fron this application!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!"
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Logged Out !",
          text: "Your Application loggedout successfully",
          icon: "success"
        });
        handleLogOut()
      }
    });
  }

  // >>>>Handle Password All Input<<<<
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // >>>>Toggle Password Modal<<<<
  const toggleChangePasswordModal = () => setChangePasswordModal(!changePasswordModal);

  // >>>>Handle Change Password<<<<
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { cnfPassword, newPassword } = formData
    if (newPassword?.trim() === "") {
      return toast.error("Please enter password...!")
    } else if (cnfPassword?.trim() === "") {
      return toast.error("Please enter confirm password...!")
    } else if (newPassword !== cnfPassword) {
      return toast.error("Confirm password does not match the New password...!")
    } else {
      const data = {
        password: cnfPassword
      }
      const res = await HttpClient.requestData("admin-change-password", "PUT", data);
      if (res && res?.status) {
        toast.success(res?.message || "Password changed successfully.!")
        setFormData(initData)
        toggleChangePasswordModal();
      } else {
        return toast.error(res?.message || "Something went wrong...!")
      }
    }
  };


  // >>>>fetch Admin Login Data<<<<
  const fetchAdminLoginData = async () => {
    const res = await HttpClient.requestData("profile", "GET")
    console.log("logindata", res)
    if (res && res?.status) {
      setLoginData(res?.data)
      console.log("4vg684fdg6dfdf", res?.data)
    }
  }

  useEffect(() => {
    fetchAdminLoginData()
  }, [])


  return (

    <div style={{ background: "red" }}>
      <section className="mainheader_sec" style={{ background: "#e60606", color: "white" }}>
        <button
          className="responsive_menu"
          style={{ color: "white" }}
          id="responsiveMenu"
          onClick={handClick}
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        <button className="responsSearch_btn" onClick={responSearch}>
          <i className="fa-solid fa-magnifying-glass"></i>
        </button>

        <div className="Search_box">

        </div>

        <div className="rightcontent">
          <div className="actionBtn_wrap">


            {/* account Details */}
            <div className="Accountdetails">
              <div className="profile_pic d-flex justify-content-center" style={{ border: "1px solid #fff" }}>
                <i class="fa-solid fa-user fa-xl" style={{ marginTop: "17px" }}></i>
                {/* <img src={profileP} className="img-fluid" alt="user" /> */}
              </div>
              <div className="namearea">
                <div className="dropdown" >
                  <Link
                    className="dropdown-toggle"
                    href="#"
                    id="accountDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    <strong>{loginData?.name}</strong>
                    <span>{loginData?.email}</span>
                  </Link>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="accountDropdown"
                  >
                    <Link className="dropdown-item"><i className="fa-solid fa-user mr-1"></i> Profile</Link>

                    <div className="mt-1" style={{ borderTop: "1px solid #ccc" }}>
                      <button className="dropdown-item" onClick={toggleChangePasswordModal}><i class="fa-solid fa-square-pen mr-1"></i> Change Password</button>
                    </div>
                    <div className="mt-1" style={{ borderTop: "1px solid #ccc" }}>
                      <button className="dropdown-item" onClick={handleLogoutNew}><i className="fa-solid fa-right-from-bracket mr-1"></i> Log Out</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {Searchmodal && (
        <div className="responsiveSearch_box">
          <form className="form-inline">
            <input
              className="form-control"
              type="search"
              placeholder="Search here...."
              aria-label="Search"
            />
            <button
              className="Search_icon"
              type="submit"
              onClick={() => setSearchmodal(false)}
            >
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
          </form>
        </div>
      )}

      {notificationmodal && (
        <NotificationModal closeModal={setNotificationmodal} />
      )}

      {/* Change Password Modal */}
      <Modal isOpen={changePasswordModal} toggle={toggleChangePasswordModal}>
        <ModalHeader toggle={toggleChangePasswordModal}>Change Password</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup className="position-relative">
              <Label for="oldPassword">New Password</Label>
              <Input
                type={showOldPassword ? "text" : "password"}
                name="newPassword"
                id="newPassword"
                placeholder="******"
                value={formData.newPassword}
                onChange={handleChange}
              />
              <div
                className="position-absolute"
                style={{ top: "50%", right: "10px", transform: "translateY(-50%)", marginTop: "1em" }}
                onClick={() => setShowOldPassword(!showOldPassword)}
              >
                {showOldPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </FormGroup>
            <FormGroup className="position-relative">
              <Label for="newPassword">Confirm Password</Label>
              <Input
                type={showNewPassword ? "text" : "password"}
                name="cnfPassword"
                id="cnfPassword"
                placeholder="******"
                value={formData.cnfPassword}
                onChange={handleChange}
              />
              <div
                className="position-absolute"
                style={{ top: "50%", right: "10px", transform: "translateY(-50%)", marginTop: "1em" }}
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </FormGroup>
            <ModalFooter>
              <div className="d-flex w-100 gap-2">
                <button className="btn btn-outline-success w-50" type="submit">Submit</button>
                <button className="btn btn-outline-danger w-50" onClick={toggleChangePasswordModal}>Cancel</button>
              </div>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>

      <Sidebar />
    </div>
  )
}

export default Header